var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'dp-content-section': true,
    'dp-content-section--no-margins': _vm.noMargins,
  }},[(_vm.title)?_c('div',{staticClass:"dp-content-section__header"},[(_vm.icon)?_c('dp-icon',{attrs:{"name":_vm.icon}}):_vm._e(),_c('h3',{class:{
        'dp-content-section__header-text': true,
        'dp-content-section__header-text--with-icon': !!_vm.icon,
      }},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1):_vm._e(),_c('div',{class:{
      'dp-content-section__content': true,
      'dp-content-section__content--no-padding': _vm.noPadding
    }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }